import React from 'react'
import Head from '../components/Head'
import Header from '../components/Header'
import Intro from '../components/IntroScholarships'
import ScholarshipCard from '../good_components/ScholarshipCard'
import InquiryCard from '../good_components/InquiryCard'
import Button from '../components/Button'
import Footer from '../components/footer'

/**
 * Randomly shuffle an array
 * https://stackoverflow.com/a/2450976/1293256
 * @param  {Array} array The array to shuffle
 * @return {String}      The first item in the shuffled array
 */
var shuffle = function(array) {
  var currentIndex = array.length
  var temporaryValue, randomIndex

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex)
    currentIndex -= 1

    // And swap it with the current element.
    temporaryValue = array[currentIndex]
    array[currentIndex] = array[randomIndex]
    array[randomIndex] = temporaryValue
  }

  return array
}

// const all_scholarships = shuffle(require('../data/scholarships.json'))
const all_scholarships = shuffle(require('../data/scholarships.json'))
const all_representatives = require('../data/representatives.json')

export default class extends React.Component {
  constructor(props) {
    super(props)

    this.loadMore = this.loadMore.bind(this)

    this.state = {
      index: 8,
      showButton: true
    }
  }

  loadMore() {
    if (this.state.index + 12 >= all_scholarships.length) {
      all_scholarships.push({
        school: 'Coming Soon',
        state: 'US',
        logo: '',
        link: 'https://playvs.com'
      })
      this.setState({ index: this.state.index + 12, showButton: false })
    } else {
      this.setState({ index: this.state.index + 12 })
    }
  }

  render() {
    const scholarships = all_scholarships.slice(0, this.state.index)
    const representative = all_representatives.find(r => r.header == "Scholarship inquiries")

    return (
      <React.Fragment>
        <Head
          title="PlayVS | Scholarships"
          description="PlayVS is the official high school esports league, sanctioned by the NFHS. Play with your friends, compete for your school, and win the state championship."
          keywords="esports college scholarships"
        />

        <Header />

        <Intro />

        <section>
          <div className="section__head">
            <h2>University Esport Programs</h2>
            <p>
              Collegiate esports programs let students continue competing while pursuing higher education. Many of them are actively recruiting high school players for their teams.{' '}
            </p>
          </div>
          <div className="section__body">
            <div className="row">
              {scholarships.map(scholarship => {
                return (
                  <ScholarshipCard
                    key={`${scholarship.school}-${scholarship.state}`}
                    name={scholarship.school}
                    logo={`images/college-logos/${scholarship.id}${scholarship.extension}`}
                    link={scholarship.link}
                  />
                )
              })}
            </div>
          </div>
          <div className="section__CTA">
            {this.state.showButton && (
              <Button type="button" className="btn btn__default" text="Load more" onClick={this.loadMore} />
            )}
          </div>
        </section>
        <div className="row" style={{marginBottom: '7.5rem'}}>
          <InquiryCard
            header={representative.header}
            name={representative.name}
            photo={representative.photo}
            title={representative.title}
            email={representative.email}
            />
        </div>

        <Footer />

      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/common/ui/pages/scholarships.js